export const REMOVE_VIDEO_SUCCESS = 'Video removido com sucesso';
export const REMOVE_VIDEO_ERROR = 'Falha ao remover o video desejado';

export const REMOVE_VIDEO_MSG = (value: string) =>
  `Tem certeza que deseja excluir o vídeo "${value}"? Ao confirmar essa ação não é possível reverter.`;
